import { createAccessControl } from "better-auth/plugins/access";
import {
	adminAc,
	defaultStatements,
	userAc,
} from "better-auth/plugins/admin/access";

const statements = {
	...defaultStatements,
} as const;

const ac = createAccessControl(statements);

// Canonical platform role axis: {superuser, user}.
//   - superuser = fully-privileged cross-org platform admin (adminAc)
//   - user      = default for everyone (userAc, non-admin)
// The retired uppercase aliases (ADMIN / AGENT / SUPERUSER) were dropped with
// the BA-canonical migration; see web access-control.test.ts.
const superuserRole = ac.newRole(adminAc.statements);
const userRole = ac.newRole(userAc.statements);

export const adminAccessControl = {
	ac,
	roles: {
		superuser: superuserRole,
		user: userRole,
	},
} as const;
